/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{76F083DB-340F-4B11-A854-43DA2812B289}",
  "sitecoreApiHost": "https://ford2go.se",
  "jssAppName": "Ford2GoSite",
  "daweroHost": "https://dawero.se",
  "graphQLApiHost": "http://ford2go.se",
  "hedinApi": {
    "host": "https://api.hedinit.se",
    "headers": {
      "x-api-key": "xYHe2UQ8mT6fzKrG34gnM1fbxGA549yAaGhqqiIP",
      "Content-Type": "application/json",
      "Accept": "application/json"
    }
  },
  "defaultLanguage": "sv-SE",
  "graphQLEndpointPath": "/api/Ford2GoSite",
  "graphQLEndpoint": "http://ford2go.se/api/Ford2GoSite?sc_apikey={76F083DB-340F-4B11-A854-43DA2812B289}"
};